import React from "react";
import Skeleton from "react-loading-skeleton";
import PropTypes from "prop-types";

const UserList = ({ userList, accessLoading, onDeleteAccess }) => {
  if (accessLoading) {
    return (
      <tr>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
        <td>
          <Skeleton count={1} />
        </td>
      </tr>
    );
  } else if (userList.length === 0) {
    return (
      <tr style={{ top: "50%", left: "50%", position: "fixed" }}>
        <td>
          <span className=""> No Record Found</span>
        </td>
      </tr>
    );
  } else if (
    typeof userList !== "undefined" &&
    userList !== null &&
    userList.length > 0
  ) {
    return userList.map((detailAccess, index) => (
      <tr key={index}>
        <td>
          <span className="">{index + 1}</span>
        </td>
        <td>
          <span className="">{detailAccess.workerFullName}</span>
        </td>
        <td>
          <span className="">{detailAccess.locationName}</span>
        </td>
        <td>
          <span className="">{detailAccess.moduleType}</span>
        </td>
        <td>
          <span className="">{detailAccess.accessGivenByName}</span>
        </td>
        <td>
          <span className="">
            {new Date(
              detailAccess.accessGivenTime
            ).toLocaleDateString()}
          </span>
        </td>
        <td
          className="text-center"
          onClick={(e) => onDeleteAccess(e, detailAccess)}
        >
          <button className="button ">Delete</button>
        </td>
      </tr>
    ));
  }
};

UserList.propTypes = {
  userList: PropTypes.array.isRequired,
  accessLoading: PropTypes.bool.isRequired,
  onDeleteAccess: PropTypes.func.isRequired
};

export default UserList;
